module.exports = __webpack_public_path__ + "img/club-pi.c605bed7.jpg";